import border from '../../border';

const secondary = (params) => border.active.secondary(params);

export default secondary;
